import { render, staticRenderFns } from "./right_3.vue?vue&type=template&id=d28ccbe0&scoped=true&"
import script from "./right_3.vue?vue&type=script&lang=js&"
export * from "./right_3.vue?vue&type=script&lang=js&"
import style0 from "./right_3.vue?vue&type=style&index=0&id=d28ccbe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28ccbe0",
  null
  
)

export default component.exports